const dataHtml =  html => ({ __html: html });
export default dataHtml
